import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import Modal from 'shared/migration-components/modal';

import {ModalContent, Inputs} from './styles';
import {handleGetInput} from '../../../../util/handle-get-input';
import {BaseInputProps} from 'shared/migration-components/form';
import Button from 'shared/migration-components/button';
import useFormInputs from 'shared/migration-components/form/util';
import {AddressProps, translatedAddressProps} from 'modules/addresses/types';
import {IoSearch} from 'react-icons/io5';
import useCitiesSelect from 'modules/cities/hooks/use-cities-select';
import useNeighborhoodsSelect from 'modules/neighborhoods/hooks/use-neighborhoods-select';
import statesSelectData from 'modules/addresses/util/states-select-data';

interface Props {
  title: string;
  opened: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  resetSearch: () => void;
  defaultValues?: any;
  withSearch?: boolean;
}

const DynamicSectionModal: React.FC<Props> = ({
  title,
  opened,
  onClose,
  onSubmit,
  defaultValues,
  resetSearch,
  withSearch,
}) => {
  const [cityId, setCityId] = useState<string>();
  const formContext = useForm({defaultValues});
  const {getInput, getSelect} = useFormInputs<AddressProps>();
  const citiesQuery = useCitiesSelect();
  const neighborhoodsQuery = useNeighborhoodsSelect(cityId);
  const formState = formContext.watch();

  useEffect(() => {
    if (defaultValues?.city) {
      const isCity = citiesQuery.data.find(
        (city) => city.label === defaultValues.city,
      );

      if (isCity) formContext.setValue('cityId', isCity.value);
    }
  }, [citiesQuery]);

  useEffect(() => {
    if (!cityId || cityId !== formState.cityId) setCityId(formState.cityId);
  }, [formState]);

  const inputs: (() => BaseInputProps)[] = [
    getInput({
      name: 'street',
      placeholder: 'Informe a rua',
    }),
    getInput({
      name: 'number',
      placeholder: 'Informe o número',
      gridColumn: 6,
    }),
    getSelect({
      name: 'cityId',
      placeholder: 'Informe a cidade',
      gridColumn: 6,
      data: citiesQuery.data,
      isLoading: citiesQuery.isLoading,
    }),
    getSelect({
      name: 'neighborhoodId',
      placeholder: 'Informe o bairro',
      gridColumn: 6,
      data: neighborhoodsQuery.data,
      isLoading: neighborhoodsQuery.isLoading,
    }),
    getSelect({name: 'state', data: statesSelectData, gridColumn: 6}),
  ];

  return (
    <FormProvider {...formContext}>
      <Modal
        titleBar={{
          title,
          actionButton: withSearch
            ? {
                label: 'Procurar endereço',
                icon: <IoSearch />,
                onClick: resetSearch,
              }
            : undefined,
        }}
        size={1200}
        {...{opened, onClose}}
        zIndex={5000}>
        <ModalContent>
          <Inputs>
            {inputs.map((getInput) =>
              handleGetInput(
                {...getInput(), border: true},
                translatedAddressProps,
              ),
            )}
          </Inputs>
          <Button
            title="Salvar"
            onClick={() => onSubmit(formContext.getValues())}
          />
        </ModalContent>
      </Modal>
    </FormProvider>
  );
};

export default DynamicSectionModal;
